import React, { useEffect } from "react";
import CustomInputField from "../../../CustomHTMLElements/CustomInputField";
import { appInsights } from "../../../../config/appInsights";
import { Loader } from "../../../../UI/Loaders/Loaders";
import { useIndividualCustomerDetails } from "../../../../custom-hooks/useIndividualCustomer";
import { useRouteMatch } from "react-router-dom";
import useCountryCodes from "../../../../custom-hooks/useCountryCodes";
import { getCountry } from "../../../AggregatorOnboardingReview/Tabs/helper";
import { Badge, Dropdown, Tag } from "antd";
import CustomTextArea from "../../../../NewComponents/TypedComponents/CustomHTMLElements/CustomTextArea";
import { ItemType } from "antd/es/menu/interface";
import useDocumentViewer from "../../../../NewComponents/CustomViewDocumentHandler/CustomViewDocumentHandler";

const IndividualResidentialAddressTab: React.FC = () => {
  const match = useRouteMatch();
  const { id } = match?.params as { id: string };

  useEffect(() => {
    appInsights.trackPageView({
      name: "IndividualResidentialAddressTabs",
      isLoggedIn: true,
    });
  }, []);

  const {
    data: customerData,
    isLoading,
    isError,
  } = useIndividualCustomerDetails({
    customerId: Number(id),
  });

  const { data } = useCountryCodes();

  if (isLoading)
    return <Loader centered={true} text="Loading customer accounts..." />;

  if (isError)
    return (
      <div>
        <div className="grid__padding animated fadeInRight">
          <h4 className="center-txt p-y-5">
            <i className="fas fa-bell" /> There was an issue while fetching
            customer accounts, Please Reload The Page{" "}
          </h4>
        </div>
      </div>
    );

  const { addressVerificationCertificatePath, googleMapUrl } =
    customerData?.data?.residentialDetails ?? {};

  const certificateItems: ItemType[] = [
    {
      key: "addressVerificationCertificatePath",
      label: "View Certificate",
    },
    { key: "view_location", label: "View Location" },
  ];

  const defaultItems: ItemType[] = [
    { key: "view_location", label: "View Location" },
  ];

  return (
    <div className="container">
      <div className="d-flex justify-content-between">
        <h3>
          Address Verification Status:{" "}
          <Tag
            style={{
              height: "fit-content",
              fontSize: 12,
              textAlign: "center",
            }}
          >
            {!customerData?.data.residentialDetails.status
              ? "NIL"
              : customerData?.data.residentialDetails.status}
          </Tag>
        </h3>
        <Dropdown
          trigger={["click"]}
          menu={{
            items: addressVerificationCertificatePath
              ? certificateItems
              : defaultItems,
            onClick: ({ key }) => {
              if (key === "view_location" && googleMapUrl) {
                window.open(googleMapUrl, "_blank");
              }

              if (key === "addressVerificationCertificatePath") {
                window.open(
                  `https://advanclystorage.blob.core.windows.net/advancly/${addressVerificationCertificatePath!}`
                );
              }
            },
          }}
        >
          <button className="btn advancly-btn m-0">Take Action</button>
        </Dropdown>
      </div>

      <div className="row">
        {/* First Column */}
        <div className="col-md-6">
          <div className="mt-4">
            <CustomInputField
              label="State"
              type="text"
              name="state"
              disabled
              defaultValue={customerData?.data.residentialDetails.state}
            />
          </div>

          <div className="mt-4">
            <CustomInputField
              label="Country"
              type="text"
              name="country"
              disabled
              defaultValue={getCountry(
                customerData?.data.residentialDetails.countryCode || "",
                data || []
              )}
            />
          </div>
        </div>

        {/* Second Column */}
        <div className="col-md-6">
          <div className="mt-4">
            <CustomInputField
              label="City"
              type="text"
              name="city"
              disabled
              defaultValue={customerData?.data.residentialDetails.city}
            />
          </div>

          <div className="mt-4">
            <CustomTextArea
              label="Address"
              name="address"
              disabled
              defaultValue={customerData?.data.residentialDetails.address}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default IndividualResidentialAddressTab;
